import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-frontend-tech }}\n<BootError />",{ moduleName: "embercom/templates/apps/error.hbs" })